import { BrowserCacheLocation, Configuration, PublicClientApplication } from "@azure/msal-browser";
import { config } from "./configuration";

export const SCOPES = {
  API: [`${config.azureAudience}/access_as_user`] as string[],
  MS_GRAPH: ["User.Read", "User.ReadBasic.All"] as string[],
} as const;

const msalConfiguration: Configuration = {
  auth: {
    clientId: config.azureClientId,
    authority: `https://login.microsoftonline.com/${config.azureTenantId}`,
    redirectUri: config.url,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

export const msalInstance = new PublicClientApplication(msalConfiguration);
